import { FavouriteDataAdapter } from './favourite-data-adapter';
import { LayoutConfig } from './layout-config';
import { ErrorHandler } from './error-handler';
import { DrillDownHandler } from './drill-down-builder';
import { FavouriteDataModel } from 'app/components/favourite-layout/favourite/common/favourite-interfaces';
import { DrillDownCallback, CaseViewCallback } from 'app/components/favourite-layout/favourite/common/drill-down-model';

export class FavouriteModelComponent {
  public config: LayoutConfig;
  protected intl: any;
  protected translation: any;
  public dataModel: FavouriteDataModel;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  private errorHandler: ErrorHandler;
  private drillDown: DrillDownCallback;
  private caseview: CaseViewCallback;

  public drillDownHandler: DrillDownHandler;

  protected dataAdapter: FavouriteDataAdapter;

  constructor(config: LayoutConfig, intl: any, translation: any,
    errorHandler: ErrorHandler,
    drillDown: DrillDownCallback,
    caseview: CaseViewCallback) {
    this.config = config;
    this.intl = intl;
    this.errorHandler = errorHandler;
    this.drillDown = drillDown;
    this.caseview = caseview;
    this.translation = translation;
  }

  public receiveData(dataModel: FavouriteDataModel) {
    this.dataModel = dataModel;
    this.dataAdapter = new FavouriteDataAdapter(this.config, dataModel, this.intl, this.translation);
    this.drillDownHandler = new DrillDownHandler(this.drillDown, this.caseview, this.dataAdapter);
  }
}
